import { FC } from 'react'

import { useAppSelector } from 'hooks/store'
import {
  getActiveTabCourseOrderItem,
  getEmptyCourseOrderItem
} from 'reducers/activecourse/activecourseSlice'
import CoursesVerifySpouseForm from 'components/organisms/CoursesVerifySpouseForm'
import GoBackHeader from 'components/organisms/GoBackHeader'
import TemplateView from 'components/organisms/TemplateView'

const CourseVerifySpouseInformation: FC = () => {
  const activeCase = useAppSelector((state) => state.activeCase)
  const course = useAppSelector(getActiveTabCourseOrderItem)

  return (
    <>
      <GoBackHeader text={course?.providerName} />
      <div data-testid='course-verify-spouse-info-page'>
        <TemplateView title='Verify your spouses information'>
          <CoursesVerifySpouseForm
            activeCase={activeCase}
            course={course ? course : getEmptyCourseOrderItem()}
          />
        </TemplateView>
      </div>
    </>
  )
}

export default CourseVerifySpouseInformation
